import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/modules/directives.module';
import { EmptyStubModule } from '@app/modules/empty-stub/empty-stub.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { IonicModule } from '@ionic/angular';
import { InfoTableModule } from "../info-table/info-table.module";
import { TeamEvaluationQuestionComponent } from './team-evaluation-question.component';

@NgModule({
  declarations: [TeamEvaluationQuestionComponent],
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    EmptyStubModule,
    FullHeightContainerModule,
    InfoTableModule
],
  exports: [TeamEvaluationQuestionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TeamEvaluationQuestionModule {}
